export default {
  root: {
    color: "#484c61",
  },
};
